import React from 'react'
import { Fun, IOWidget, any, async, fromJSX, nothing } from 'widgets-for-react'
import { CollectionsLoaderState } from '../../collections/collectionsLoader/collectionsLoaderState'
import { isSaved } from '../../collections/collectionsLoader/collectionsLoaderUtils'
import { ComponentTeasersLayout, PageType } from './componentTeasersLayout'
import {
  ComponentTeasersState,
  ExtendedComponentTeasersState,
  componentTeasersStateUpdaters,
} from './componentTeasersState'

export const componentTeasersWidget =
  (
    collectionsState: CollectionsLoaderState,
    pageType: PageType,
    teasersType: 'link-only' | 'link-save' | 'link-delete',
    additionalElements?: {
      title?: string
      intro?: string
      readMoreLink?: string
    },
    isComparableComponents: boolean = false,
    hasWrapper: boolean = true
  ): IOWidget<
    ComponentTeasersState,
    Fun<ComponentTeasersState, ExtendedComponentTeasersState>
  > =>
  (componentTeasersState) =>
    any([
      async(componentTeasersState).map(
        componentTeasersStateUpdaters.componentTeasersStateUpdater
      ),
      componentTeasersState.kind == 'unloaded'
        ? nothing()
        : fromJSX((setState) => (
            <ComponentTeasersLayout
              kind={pageType}
              title={additionalElements?.title}
              intro={additionalElements?.intro}
              readMoreLink={additionalElements?.readMoreLink}
              componentTeasers={
                componentTeasersState.kind == 'loaded'
                  ? componentTeasersState.value
                  : componentTeasersState.kind == 'loading'
                  ? componentTeasersState.value == undefined
                    ? 'loading'
                    : componentTeasersState.value
                  : 'error'
              }
              teaserKind={teasersType}
              isSaved={(id) => isSaved(collectionsState, id)}
              onSaveOrDelete={(id) => {
                setState(
                  componentTeasersStateUpdaters.saveComponentIdUpdater(id)
                )
              }}
              isComparableComponents={isComparableComponents}
              hasWrapper={hasWrapper}
            />
          )),
    ])
